import React, { createElement } from "react";
import moduleCss from './index.module.scss'

export interface Footer_Props {
    nodeId?: string
    style?: object;
    year: string;

    textColor: string // 文本颜色
    hoverColor: string // 超链接 hover 时的颜色
}

const LINKS = [
    { text: '凤凰新媒体介绍', url: 'https://www.ifeng.com/corp/about/intro/' },
    { text: '投资者关系 Investor Relations', url: 'https://ir.ifeng.com/' },
    { text: '广告服务', url: 'https://biz.ifeng.com/' },
    { text: '诚征英才', url: 'https://career.ifeng.com/' },
    { text: '保护隐私权', url: 'https://www.ifeng.com/corp/privacy/' },
    { text: '免责条款', url: 'https://www.ifeng.com/corp/exemption/' },
    { text: '意见反馈', url: 'https://help.ifeng.com/' },
    { text: '凤凰卫视介绍', url: 'https://phtv.ifeng.com/intro/' },
]

const Footer: React.FC<Footer_Props> = (props) => {
    const { nodeId, year, style, textColor, hoverColor } = props

    return (
        <div id={nodeId} className={moduleCss.footer} style={{ color: textColor, ...style }}>
            <div className={moduleCss.links}>
                {
                    LINKS.map((link, index) => {
                        return (
                            <>
                                <a href={link.url} style={{ '--hover-color': hoverColor }}>{link.text}</a>
                                {
                                    index < LINKS.length - 1 &&
                                    <span className={moduleCss.divider}>|</span>
                                }
                            </>
                        )
                    })
                }
            </div>
            <div>
                <span className={moduleCss.span}>凤凰新媒体</span>
                <span className={moduleCss.span}>版权所有</span>
                Copyright © {year} Phoenix New Media Limited All Rights Reserved.
            </div>
        </div>
    )
}

export default Footer
